<template>
<section class="mall-image-data">
	<div class="mall-image-container w">
		<div class="mall-image-title">软件产品<span>SoftWare Products</span></div>
		<div class="mall-image-header">
			<el-radio-group v-model="searchType" @input="getGoodsData">
				<el-radio-button :label="null">全部</el-radio-button>
				<el-radio-button :label="item.id" v-for="item in softWareType">
					{{ item.name }}</el-radio-button>
			</el-radio-group>
			<div class="mall-image-header-search">
				<el-input v-model="searchText" placeholder="请输入检索关键词"
					@keyup.enter.native="searchDataByText"></el-input>
				<el-button type="primary" @click="searchDataByText">搜索</el-button>
			</div>
		</div>

		<div class="mall-image-content">
			<div class="mall-image-content-operate">
                <span>排序：</span>
                <el-link type="primary" :underline="false" @click="sortByPrice"
                    :class="{actived: sortType === 3 || sortType === 5}">价格
                    <i :class="[this.sortType === 3 ? 'el-icon-top':'el-icon-bottom']"></i></el-link>
                <el-link type="primary" @click="sortBySales" :underline="false"
                    :class="{actived: sortType === 2 || sortType === 7}">销量
                    <i :class="[this.sortType === 2 ? 'el-icon-top':'el-icon-bottom']"></i></el-link>
                <el-link type="primary" @click="sortByCreate" :underline="false"
                    :class="{actived: sortType === 4 || sortType === 8}">新品
                    <i :class="[this.sortType === 4 ? 'el-icon-top':'el-icon-bottom']"></i></el-link>
                <el-link type="primary" @click="sortByComment" :underline="false"
                    :class="{actived: sortType === 1 || sortType === 6}">评论量
                    <i :class="[this.sortType === 1 ? 'el-icon-top':'el-icon-bottom']"></i></el-link>
            </div>
			<div class="mall-image-goods">
				<GoodsCard v-for="item in softWareProduct" :data="item"></GoodsCard>
				<el-empty description="暂无其他类型的产品" v-if="!softWareProduct.length"></el-empty>
			</div>
			<el-pagination :current-page.sync="currentPage" @current-change="getGoodsData"
				:page-size="12" layout="total, prev, pager, next" :total="dataSum"></el-pagination>
		</div>
	</div>
	<CategorySwitch></CategorySwitch>
</section>
</template>

<script>
import GoodsCard from '../../../components/RemoteSensingMall/GoodsCard.vue'
import CategorySwitch from '../../../components/RemoteSensingMall/CategorySwitch.vue'
export default {
	name: 'SoftWareProduct',
	components: {
		GoodsCard, CategorySwitch
	},
	data() {
		return {
			searchType: null,
			searchText: null,
			sortType: 4,
			softWareProduct: [],
			softWareType: [],
			currentPage: 1,
			dataSum: 0
		}
	},
	mounted() {
		this.getSoftWareType()
		this.getGoodsData()
	},
	computed: {

	},
	methods: {
		getSoftWareType() {
			this.$http.get(this.$const.RemoteSensingMall.ClassificationOfGoods).then(res => {
				if(res.code === 200) {
					this.softWareType = res.data
				}
			}).catch(error => {
				console.log(error)
			})
		},
		getGoodsData() {
			this.$http.post(this.$const.RemoteSensingMall.requestGoodsPageDatas, {
				pageNum: this.currentPage,
				pageSize: 12,
				goodsCategory: 3,
				keyword: this.searchText,
				orderType: this.sortType,
				goodsCategoryId: this.searchType
			}).then(res => {
				if(res.code === 200) {
					this.dataSum = res.data.total
					this.softWareProduct = res.data.list
				}
			}).catch(error => {
				console.log(error)
			})
		},
		searchDataByText() {
			this.currentPage = 1
			this.getGoodsData()
		},
		advancedSearch() {
			this.currentPage = 1
			this.getGoodsData()
		},
		sortByPrice() {
            if(this.sortType === 3) { this.sortType = 5}
            else { this.sortType = 3}
            this.getGoodsData()
        },
        sortBySales() {
            if(this.sortType === 2) { this.sortType = 7}
            else { this.sortType = 2}
            this.getGoodsData()
        },
        sortByCreate() {
            if(this.sortType === 4) { this.sortType = 8}
            else { this.sortType = 4}
            this.getGoodsData()
        },
        sortByComment() {
            if(this.sortType === 1) { this.sortType = 6}
            else { this.sortType = 1}
            this.getGoodsData()
        },
	}
}
</script>

<style lang="scss" scoped>
.mall-image-data {
	width: 100%;
	background-color: #F5F5F5;

	>.mall-image-container {
		display: flex;
		flex-direction: column;

		>.mall-image-title {
			padding: 30px 0;
			padding-left: 12px;
			color: #2569F2;
			font-size: 24px;
			font-weight: 700;

			>span {
				margin-left: 20px;
				color: #798AAC;
				font-size: 16px;
			}
		}

		>.mall-image-header {
			display: flex;
			flex-direction: row;
			align-items: center;
			width: fit-content;
			margin-bottom: 32px;
			padding: 20px;
			border-radius: 6px;
			background-color: white;

			> .el-radio-group {
				margin-right: 12px;
				white-space: nowrap;
			}

			::v-deep input {
				background-color: #F5F5F5;
			}

			>.mall-image-header-search {
				display: flex;
				align-items: center;

				>button {
					margin-left: 10px;
				}

				> a {
					margin-left: 20px;
					font-size: 14px;
					white-space: nowrap;
					user-select: none;

					i {
						margin-left: 6px;
					}
				}
			}

			>.mall-image-header-advanced {
				display: flex;
				align-items: center;

				>.el-divider {
					margin: 0 20px;
				}

				>span {
					font-size: 14px;
					font-weight: 700;
					white-space: nowrap;
				}

				>.el-date-editor {
					margin: 0 20px;
					background-color: #F5F5F5;

					> ::v-deep .el-range-separator {
						margin-left: -12px;
						width: 6%;
					}
				}
				> .el-select{
					margin: 0 20px;
				}
			}
		}

		> .mall-image-content{
			display: flex;
			flex-direction: column;

			> .mall-image-content-operate{
				display: flex;
				align-items: center;
				padding: 0 12px;

				> span {
					margin-right: 40px;
					font-size: 14px;
					font-weight: 700;
				}
				> a {
                    margin: 0 30px;
                    padding: 5px 10px;
                    transition: .3s;
                    user-select: none;

                    &.actived {
                        background-color: rgba($color: #2569F2, $alpha: .15);
                        border: 1px solid #2569F2;
                        border-radius: 3px;
                    }
                    i {
                        margin-left: 6px;
                    }
                }
			}
			> .mall-image-goods{
				display: flex;
				flex-direction: row;
				align-items: center;
				flex-wrap: wrap;

				> div {
					flex: 0 0 25%;

					@media (max-width: 1024px) { flex: 0 0 33%;}
				}
				> .el-empty {
					margin: 0 auto;
				}
			}
			> ::v-deep .el-pagination{
				margin: 60px 0;

				> button {
					width: 35px;
					height: 35px;
					padding: 0;
					background-color: transparent;
					border-radius: 6px;
				}
				> ul {
					margin: 0 6px;

					> li {
						width: 35px;
						height: 35px;
						margin: 0 6px;
						background-color: transparent;
						border-radius: 6px;
						line-height: 35px;
						transition: .2s;

						&:hover {
							color: #2569F2;
						}
						&.active {
							color: white;
							background-color: #2569F2;

							&:hover {
								color: white;
							}
						}
					}
				}
			}
		}
	}
}
// 动画
.stretch-enter-active, .stretch-leave-active{
	transition: .2s;
}
.stretch-enter, .stretch-leave-to {
	opacity: 0;
}
</style>